/**
 * Decide how a reviewer finding row labels itself.
 *
 * The bold title is the bare condition name. The gray subtitle beneath it lists
 * the AI-predicted attribute descriptors (laterality / severity / size) joined by
 * dots — e.g. "Bilateral · Small" under "Renal simple cyst". Descriptors only,
 * so the subtitle stays compact instead of repeating the condition name. No
 * descriptors → no subtitle. Absence is explicit, never a silent guess.
 */
export interface ReviewerFindingDisplay {
  /** Bold title line — the bare condition name. */
  title: string;
  /** Gray subtitle line under the title; null when there are no descriptors. */
  subtitle: string | null;
}

export function reviewerFindingDisplay(params: {
  fallbackName: string;
  attributes: string[];
}): ReviewerFindingDisplay {
  const attrs = params.attributes.filter(Boolean);
  return {
    title: params.fallbackName,
    subtitle: attrs.length > 0 ? attrs.join(" · ") : null,
  };
}
